export const pushToSnackbar = 'pushToSnackbar';
export const popSnackbar = 'popSnackbar';
export const setLayout = 'setLayout';




// WEBPACK FOOTER //
// ./src/store/modules/app/actionsTypes.js